import type { FichaPresenca } from '../types';
import { formatarHora } from '../utils';
import { AvatarPessoa, PilhaEstado } from './VisualPessoa';

interface Props {
  ficha: FichaPresenca;
  naJanela: boolean;
  confirmando: boolean;
  aoConfirmar: () => void;
}

export default function CartaoMinhaPresenca({
  ficha,
  naJanela,
  confirmando,
  aoConfirmar,
}: Props) {
  const confirmada = ficha.presenca === 'confirmada';

  return (
    <section className="rounded-2xl border border-primary-300 bg-white p-4 shadow-sm">
      <div className="flex items-center gap-3">
        <AvatarPessoa nome={ficha.nome} confirmada={confirmada} />
        <div className="min-w-0 flex-1">
          <p className="text-[15px] font-bold text-foreground-950">{ficha.nome}</p>
          <p className="text-xs text-secondary-500">você</p>
        </div>
        <PilhaEstado presenca={ficha.presenca} />
      </div>

      {confirmada && ficha.registrada_em && (
        <p className="mt-3 text-xs text-secondary-500">
          às {formatarHora(ficha.registrada_em)}
        </p>
      )}

      {!confirmada && (
        <button
          type="button"
          onClick={aoConfirmar}
          disabled={!naJanela || confirmando}
          className="mt-4 flex h-11 min-h-[44px] w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 text-sm font-bold text-white transition-colors hover:bg-primary-700 disabled:cursor-not-allowed disabled:bg-secondary-300"
        >
          {confirmando ? 'Confirmando…' : 'Confirmar minha presença'}
        </button>
      )}
    </section>
  );
}